import React, { FC, ReactNode } from "react";

import styles from "./button.module.css";

type IconButtonProps = {
  icon: ReactNode;
  tooltip: string;
  onClick?: () => void;
};

const IconButton: FC<IconButtonProps> = (props) => {
  const { icon, tooltip, onClick } = props;
  return (
    <div className={styles.iconButtonContainer} onClick={onClick}>
      {icon}
      <div className={styles.tooltip}>
        <div>{tooltip}</div>
      </div>
    </div>
  );
};

export default IconButton;
